<span
  class="pin-button"
  (click)="handleClick()"
  [ngClass]="{
    'pin-button--selected': selected,
    'pin-button--disabled': disabled,
    'pin-button--small': size === 'small',
    'pin-button--medium': size === 'medium',
    'pin-button--large': size === 'large',
    'pin-button--ghost': buttonType === 'ghost',
    'pin-button--primary': buttonType === 'primary',
    'pin-button--secondary': buttonType === 'secondary',
    'pin-button--outline': buttonType === 'outline',
    'pin-button--floating': buttonType === 'floating',
    'pin-button--dark': buttonType === 'dark',
    'pin-button--row': direction === 'row',
    'pin-button--circle': buttonShape == 'circle',
    'pin-button--square': buttonShape == 'square',
    'pin-button--rounded': buttonShape == 'rounded',
    'pin-button--fill': fill,
    'pin-button--left': buttonAlign === 'left'
  }">
  <span class="pin-button__pin">
    <!-- Icon -->
    <app-icon [icon]="icon" style="font-size: 14px !important" *ngIf="icon"></app-icon>

    <!-- Image -->
    <span *ngIf="src" [style.backgroundImage]="'url(' + src + ')'" class="pin-button__image"></span>

    <ng-content></ng-content>
  </span>

  <span class="pin-button__label" *ngIf="label">
    {{ label }}
  </span>
</span>
